import Vue from 'vue'
import { i18n } from '../vendors/vue-i18n'

Vue.filter('currencyWithoutCents', value => {
  return i18n.n(value / 100, 'currencyWithoutCents')
})

Vue.filter('removeDecimal', value => {
  return `$${Math.floor(Number(value)).toLocaleString()}`
})
